import React from 'react';
import { contactTileData } from '../../shared/shared.constants';
import { Grid2 as Grid, Box } from '@mui/material';
import {
  TypographyStyledBlack,
  LinkStyled,
  Item,
  TypographyBlack
} from './style';

export const TileGroup = () => {
  return (
    <Grid container spacing={2}>
      {contactTileData.map((item) => (
        <Grid
          key={item.tileText}
          size={12}
          sx={{
            borderRadius: '0.9375rem',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <LinkStyled href={item.toLink} data-testid={item.altVal}>
            <Item
              sx={{
                boxShadow: 0,
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '0.625rem',
                alignItems: 'center',
                padding: '0.9375rem',
                borderRadius: '0.9375rem'
              }}
            >
              <Box
                sx={{
                  height: '75px',
                  width: '75px',
                  borderRadius: '100px',
                  backgroundColor: '#F2F2F2',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  src={item.imgSrc}
                  alt={item.altVal}
                  style={{
                    height: '1.875rem',
                    width: '1.875rem',
                    padding: '0.9375rem'
                  }}
                />
              </Box>

              <Box
                sx={{
                  boxShadow: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  padding: '1.25rem',
                  gap: '0.3125rem'
                }}
              >
                <TypographyStyledBlack
                  sx={{
                    color: '#002A3A',
                    lineHeight: '1.5rem'
                  }}
                >
                  {item.tileText}
                </TypographyStyledBlack>
                <TypographyBlack
                  sx={{
                    color: '#002A3A'
                  }}
                >
                  {item.tileSubText}
                </TypographyBlack>
              </Box>
            </Item>
          </LinkStyled>
        </Grid>
      ))}
    </Grid>
  );
};
